import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Row,Col } from 'react-bootstrap';
import FLogin from '../assets/formLogin';
import DstLogin from '../assets/destaqueLogin';
// import PropTypes from 'prop-types';
export default class Login extends React.Component {
    render(){
        return ( 
            <div className="container-fluid"> 
                <Row>
                    <Col xs="12" md="6" className={css(styles.divimagem)}>
                        <DstLogin/>
                    </Col>
                    <Col xs="12" md="6" className={css(styles.form)}>
                        <FLogin/>
                    </Col>
                 </Row>
            </div>
        );
    }
}
  
const styles = StyleSheet.create({
    form: {
        height: '97vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px',
        margin: '0px',
        paddingRight:'0px',
        paddingLeft:'0px',
    },
    divimagem: {
        paddingLeft:'0px',
        paddingRight:'0px',
        paddingBottom:'0px',
        '@media (max-width: 991px)': {
            height: '100px',
        }
    },
})


// WEBPACK FOOTER //
// ./src/cenas/Login.js